import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPodRow.scss';
import cx from 'classnames';

const CwPodRow = (props) => {
  return (
    <div style={props.style} className={cx(css.podRow,
      props.className
    )}>
      {props.children}
    </div>
  );
};

CwPodRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
};

export default CwPodRow;


// WEBPACK FOOTER //
// ./src/components/cwpod/CwPodRow.jsx